import React from 'react';
import './Congrat.css';
import {Modal} from 'react-bootstrap'

const Congrat = ({text, prizeName, src, show, closeModal, lang}) => {
    return (

        <Modal show={show} onHide={closeModal} size="lg" centered className={`congrat-modal my-modal ${lang}`}>
            <Modal.Header closeButton={true}>
            </Modal.Header>
            <Modal.Body closeButton>
                    <h3>{text.title}</h3>
                    <p>{text.subtitle}</p>
                    <div className='modal-img-wrapper'>
                        <img src={src} alt="prize" className="modal-img"/>
                    </div>
                    <h3>{prizeName}</h3>
                    <div>
                        <p>{text.p1}</p>
                    </div>                
            </Modal.Body>
        </Modal>

    );
};
export default Congrat
